import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { RouterModule } from '@angular/router';
import { DataSourceDirective, DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { QRCodeModule } from 'angularx-qrcode';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuctionWonListItemComponent } from './auctions/auction-won-list-item/auction-won-list-item.component';
import { AuctionWalletDetailsComponent } from './auctions/auction-wallet-details/auction-wallet-details.component';
import { RewardsWalletRedeemListItemComponent } from './rewards-wallet-redeem-list-item/rewards-wallet-redeem-list-item.component';
import { RewardsWalletRedeemListComponent } from './rewards-wallet-redeem-list/rewards-wallet-redeem-list.component';
import { LottosWalletDetailsComponent } from './lottos/lottos-wallet-details/lottos-wallet-details.component';
import { LottosWonListItemComponent } from './lottos/lottos-won-list-item/lottos-won-list-item.component';
import { MarketplacePurchasedListItemComponent } from './marketplace/marketplace-purchased-list-item/marketplace-purchased-list-item.component';
import { MarketplaceWalletDetailsComponent } from './marketplace/marketplace-wallet-details/marketplace-wallet-details.component';
import { RewardsWalletRedeemedListComponent } from './rewards-wallet-redeemed-list/rewards-wallet-redeemed-list.component';
import { RewardsWalletRedeemedListItemComponent } from './rewards-wallet-redeemed-list-item/rewards-wallet-redeemed-list-item.component';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { AddToCalendarModalModule } from './marketplace/marketplace-wallet-details/add-to-calendar-modal/add-to-calendar-modal.module';
import { ExpiredPillComponent } from './shared/expired-pill/expired-pill.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WalletTransferredListComponent } from './wallet-transferred-list/wallet-transferred-list.component';

@NgModule({
  declarations: [
    AuctionWonListItemComponent,
    AuctionWalletDetailsComponent,
    LottosWonListItemComponent,
    LottosWalletDetailsComponent,
    MarketplacePurchasedListItemComponent,
    MarketplaceWalletDetailsComponent,
    RewardsWalletRedeemListComponent,
    RewardsWalletRedeemListItemComponent,
    RewardsWalletRedeemedListComponent,
    RewardsWalletRedeemedListItemComponent,
    WalletTransferredListComponent,
  ],
  imports: [
    CommonModule,
    PipesModule,
    ShortLongDescriptionModule,
    NgbModule,
    ErrorsModule,
    RouterModule,
    LoadingModule,
    DirectivesModule,
    QRCodeModule,
    CarouselModule,
    FGBSharedModule,
    DataSourceDirective,
    AddToCalendarModalModule,
    ExpiredPillComponent,
    InlineSVGModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    RewardsWalletRedeemListComponent,
    RewardsWalletRedeemedListComponent,
    LottosWalletDetailsComponent,
    AuctionWalletDetailsComponent,
    MarketplaceWalletDetailsComponent,
    WalletTransferredListComponent,
  ],
})
export class WalletModule {}
